export const version = "contracts/5.0.2";
//# sourceMappingURL=_version.js.map